import React from 'react';
import Fieldset from 'components/fieldset';
import { observer } from 'mobx-react';

const withLegend = Component => {

  @observer
  class WithLegendComponent extends React.Component {

    render() {
      const { legend, ...restProps } = this.props;

      if (legend) {
        return (
          <Fieldset>
            <legend>{legend}</legend>
            <Component {...restProps} />
          </Fieldset>
        );
      }

      return <Component {...this.props} />;
    }
  }

  return WithLegendComponent;
};

withLegend.displayName = 'withLegend';
export default withLegend;